import React, { useEffect, useState } from 'react'
import { Jumbotron, Container, Row, Col, Accordion, Card, Button } from 'react-bootstrap'
import careerImage from '../../assets/images/careers.jpg'
import { FadeOnUp } from 'nehoa'
import API from '../../utils/API'
import parse from 'html-react-parser';
import './index.css'

export default function Careers() {

    const [jobPosts, setJobPosts] = useState([])

    function getInfo() {
        API.getJobPosts().then(
            function (response) {
                var parseString = require('xml2js').parseString
                var xml = response.data
                parseString(xml, function (err, result) {
                    // console.log(result.source)
                    setJobPosts(result.source.job)
                });
            })
    }

    useEffect(() => {
        getInfo()
    }, []);

    return (
        <>
            <Jumbotron style={{ paddingTop: '0', backgroundColor: '#999999', backgroundImage: `url(${careerImage})`, backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', height: '60vh' }} fluid><FadeOnUp duration='3s'><div className="pageBannerTitleDiv"><p className="mainTitleFont">Careers</p></div></FadeOnUp></Jumbotron>
            <Container>
                <Row>
                    <Col>
                        <div>
                            Please click on the correpsonding url to the job you would like to apply for or email your cover letter and resume to <a href="mailto:Jobs@carehawaii.com">Jobs@carehawaii.com</a>.When applying by email please
                    indicate in the subject box the location and job title that you are applying for.
                </div>
                    </Col>
                </Row>
                <Row>

                    <Col>
                    <br /><br />
                        <Accordion defaultActiveKey="0">

                            {jobPosts.map(item => (
                            <Card key={item.referenceNumber}>
                                <Card.Header>
                                    <Accordion.Toggle as={Button} variant="link" eventKey={item.referenceNumber}>
                                    <div className="mainFont" style={{ fontSize: '1em', color: '#000000', display: 'inline'}}> {parse("" + item.csTitle)}</div>
                                    <div style={{fontSize: '0.85em', color: '#000000', display: 'inline'}}>{parse("    " + item.city)} {parse(", " + item.state + " ")}{parse(", " + item.country + " ")}{parse(" | " + item.employmentType + " ")}</div>
                                </Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey={item.referenceNumber}>
                                    <Card.Body>
                                        <div className="mainFont" style={{ fontSize: '1em' }}>{parse("Job Title : " + item.csTitle)}</div><hr />
                                        <div className="mainFont" style={{fontSize: '0.75em'}}>{parse("Location: " + item.city)} {parse(", " + item.state + " ")}{parse(", " + item.country + " ")}</div>
                                        <div className="mainFont" style={{ fontSize: '0.75em' }}>Position type: {parse("" + item.employmentType)}</div>
                                        {/* <div className="mainFont" style={{ fontSize: '0.75em' }}>URL: <a href={item.url}>{parse("" + item.url)}</a></div> */}
                                        <div className="mainFont" style={{ fontSize: '0.75em' }}>URL: <a href="mailto:Jobs@carehawaii.com">Jobs@carehawaii.com</a></div>
                                        <div className="mainFont" style={{ fontSize: '0.75em' }}>{parse("" + item.csDescription)}</div>
                                        
                                        </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                            ))}
                
                        </Accordion>
                     

                    </Col>
                </Row>
            </Container>
            <br /><br />
        </>
    )
}
